export default __webpack_public_path__ + "static/media/BG_header@2x.eca056a7.jpg";